import React, { useEffect, useState } from 'react'
import {
  Alert,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Input,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
  Typography,
  useTheme,
} from '@mui/material'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'
import moment from 'moment-timezone'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from '@mui/x-date-pickers'
import { CalendarIcon } from '../../assets/icons/icons'
import PlaceComponent from '../Place'
import { useGetAdminAndSupers } from '../../features/settings/hooks'
import ClearIcon from '@mui/icons-material/Clear'
import SelectTagsComponent from '../../features/projects/uploads/SelectTagsComponent'

export const ProjectForm = (props: any) => {
  const {
    onSubmit,
    onSave = null,
    record = {},
    onFormDataChange,
    externalError = null,
    submitLabel = 'Save',
  } = props
  const [formData, setFormData] = useState<any | undefined>(record)
  const [isvalidemail, setisvalidemail] = useState<boolean | undefined>(record)
  const [ishrvalidemail, sethrViolationNotifyEmails] = useState<
    boolean | undefined
  >(record)
  const [isvalidemailnotifi, setvalidemailnotifi] = useState<
    boolean | undefined
  >(record)
  const navigate = useNavigate()
  let timeFieldNames: String[] = []
  const theme = useTheme()
  const { data: accountUsers, refetch } = useGetAdminAndSupers('users')
  const existingUsers = formData['superintendents']
    ? formData['superintendents'].map((v: any) => v._id)
    : []
  const [users, setUsers] = useState<any>(existingUsers)
  const [personName, setPersonName] = React.useState([])
  const [kioskEnabled, setKioskEnabled] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [dailyGraceError, setDailyGraceError] = useState<string | null>(null)
  const submitHandler = (event: React.SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (!formData['projectName'] || formData['projectName'].trim() === '') {
      setError('Please enter a valid project name')
      return
    }
    setError(null)
    onSubmit(formData)
  }
  const isValidEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  useEffect(() => {
    if (record) {
      if (record.automaticClockOut) {
        record.automaticClockOutEnabled = !!record?.automaticClockOut?.enabled
        record.automaticClockOutTime = `${dayjs().format('MM/DD/YYYY')} ${
          record.automaticClockOut.time
        }`
      }
      if (record.kioskMode) {
        record.kioskEnabled = record.kioskMode.enabled
        setKioskEnabled(!!record.kioskEnabled)
      }
      setFormData(record)
    }
  }, [record])

  useEffect(() => {
    refetch()
  }, [])

  const onDataEntry = (
    event?: React.ChangeEvent<HTMLInputElement> | any,
    fieldName?: string
  ) => {
    let updateData = { ...formData }
    if (event?.hasOwnProperty('target')) {
      const newValue = event.target.value

      switch (fieldName) {
        case 'clientEmails':
          const isValidEmailFlag = isValidEmail(newValue)
          setisvalidemail(isValidEmailFlag)
          updateData[fieldName] = newValue
          break
        case 'hrViolationNotifyEmails':
          const trimmedEmails = newValue.map((email: string) => email.trim())
          const isValidHRViolationEmails = trimmedEmails.every(isValidEmail)
          sethrViolationNotifyEmails(isValidHRViolationEmails)
          updateData[fieldName] = trimmedEmails
          break
        case 'clientName':
          const clientName = newValue.slice(0, 20)
          updateData[fieldName] = clientName
          break
        case 'service':
          const service = newValue.slice(0, 100)
          updateData[fieldName] = service
          break
        case 'projectName':
          const projectName = newValue.slice(0, 30)
          updateData[fieldName] = projectName
          break
        case 'notificationEmails':
          const isValidEmailFlag2 = isValidEmail(newValue)
          setvalidemailnotifi(isValidEmailFlag2)
          updateData[fieldName] = newValue
          break

        case 'dailyGraceTime':
          if (newValue == 0 && newValue !== '') {
            setDailyGraceError('Daily grace time should be greater than 0.')
          } else {
            setDailyGraceError(null)
            if (newValue === '') {
              console.log('newValue', newValue)
              updateData[fieldName] = formData.dailyGraceTime
            } else {
              updateData[fieldName] = newValue
            }
        }
          break

        case 'dailyStartTime':
          updateData[fieldName] = newValue ? dayjs(newValue) : null
          break

        default:
          updateData[event.target.name] = newValue
          break
      }
      if (fieldName === 'projectName') {
        if (newValue.trim() !== '') {
          setError(null)
        } else if (
          !formData['projectName'] ||
          formData['projectName'].trim() === ''
        ) {
          setError('Please enter a valid project name')
        }
      }
    } else if (dayjs(event).isValid() && fieldName) {
      updateData[fieldName] = event
    } else if (event?.name) {
      updateData[event.name] = event.value
    }

    setFormData(updateData)

    if (onFormDataChange) {
      onFormDataChange(updateData)
    }
  }

  const timezones = moment.tz
    .names()
    .map(name => ({ label: name, value: name }))
  return (
    <>
      <div style={{ height: '100%' }}>
        <form onSubmit={submitHandler}>
          <Box>
            {externalError && (
              <Alert severity='error' sx={{ marginBottom: 2 }}>
                {externalError}
              </Alert>
            )}
          </Box>
          <Box sx={{ marginBottom: 3 }}>
            <Box
              sx={{
                width: '100%',
                backgroundColor: 'white',
                padding: 3,
                boxShadow: '0px 2px 4px 0px #0000000D',
                borderRadius: '8px',
              }}>
              <Grid container spacing={4}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexDirection: 'column',
                  }}>
                  <Box width='100%'>
                    <Typography
                      fontSize={'14px'}
                      color='#5A525B'
                      paddingBottom={0.5}
                      fontWeight='bold'>
                      Project Name
                    </Typography>
                    <Box
                      sx={{
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        border: '1px solid #DBDBDB',
                        padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                      }}
                      display={'flex'}
                      alignItems={'center'}
                      justifyContent={'center'}>
                      <Input
                        disableUnderline
                        sx={{
                          width: '100%',
                          fontSize: '17px',
                          '& input::placeholder': {
                            fontWeight: 'bold',
                          },
                        }}
                        name={'projectName'}
                        type='text'
                        fullWidth={true}
                        onChange={event => onDataEntry(event, 'projectName')}
                        value={formData['projectName'] || ''}
                        disabled={false}
                      />
                    </Box>
                    {error && (
                      <div
                        style={{ color: 'red', margin: theme.spacing(1, 0) }}>
                        {error}
                      </div>
                    )}
                  </Box>

                  <Box width='100%'>
                    <Typography
                      fontSize={'14px'}
                      color='#5A525B'
                      paddingBottom={0.5}
                      fontWeight='bold'>
                      Project Number
                    </Typography>
                    <Box
                      sx={{
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        border: '1px solid #DBDBDB',
                        padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                      }}
                      display={'flex'}
                      alignItems={'center'}
                      justifyContent={'center'}>
                      <Input
                        disableUnderline
                        sx={{
                          width: '100%',
                          fontSize: '17px',
                          '& input::placeholder': {
                            fontWeight: 'bold',
                          },
                        }}
                        name={'projectNumber'}
                        type='text'
                        fullWidth={true}
                        onChange={onDataEntry}
                        value={formData['projectNumber'] || ''}
                        required={true}
                        disabled={false}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    Project Description
                  </Typography>
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '1px solid #DBDBDB',
                      padding: theme.spacing(1, 1.6, 1, 1.6),
                    }}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}>
                    <Input
                      disableUnderline
                      multiline
                      sx={{
                        width: '100%',
                        fontSize: '17px',
                        '& input::placeholder': {
                          fontWeight: 'bold',
                        },
                      }}
                      name={'projectDescription'}
                      type='text'
                      rows={5}
                      fullWidth={true}
                      onChange={onDataEntry}
                      value={formData['projectDescription'] || ''}
                      required={true}
                      disabled={false}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    Project Due
                  </Typography>
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '1px solid #DBDBDB',
                      padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                    }}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={formData['projectDueDate'] ?? ''}
                        onChange={e => onDataEntry(e, 'projectDueDate')}
                        minDate={new Date()}
                        renderInput={(params: any) => {
                          console.log(params.InputProps?.endAdornment?.props)
                          return (
                            <TextField
                              {...params}
                              variant='standard'
                              name='projectDueDate'
                              label=''
                              required
                              value={params.inputProps.value}
                              type={params.inputProps.type}
                              placeholder={params.inputProps.placeholder}
                              onChange={params.inputProps.onChange}
                              className={params.className}
                              disabled={
                                params.inputProps.disabled == undefined
                                  ? true
                                  : true
                              }
                              inputProps={{
                                ...params,
                                disabled: true,
                                readOnly: true,
                              }}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  // @ts-ignore
                                  <IconButton
                                    {...params.InputProps}
                                    onClick={event => {
                                      // @ts-ignore
                                      params.InputProps.endAdornment.props.children.props.onClick()
                                    }}>
                                    <CalendarIcon />
                                  </IconButton>
                                ),
                              }}
                              sx={{
                                width: '100%',
                                '& .MuiInput-underline:before': {
                                  display: 'none',
                                },
                                '& .MuiInput-underline:hover:not(.Mui-disabled):before':
                                  {
                                    display: 'none',
                                  },
                                '& .MuiInput-underline:after': {
                                  display: 'none',
                                },
                              }}
                            />
                          )
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    Client Name
                  </Typography>
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '1px solid #DBDBDB',
                      padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                    }}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}>
                    <Input
                      disableUnderline
                      sx={{
                        width: '100%',
                        fontSize: '17px',
                        '& input::placeholder': {
                          fontWeight: 'bold',
                        },
                      }}
                      name={'clientName'}
                      type='text'
                      fullWidth={true}
                      onChange={e => onDataEntry(e, 'clientName')}
                      value={formData['clientName'] || ''}
                      required={true}
                      disabled={false}
                    />
                  </Box>
                </Grid>
                {/* Client Email(s) */}
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    Client Email(s)
                  </Typography>
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '1px solid #DBDBDB',
                      padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                    }}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}>
                    <Input
                      disableUnderline
                      sx={{
                        width: '100%',
                        fontSize: '17px',
                        '& input::placeholder': {
                          fontWeight: 'bold',
                        },
                      }}
                      name={'clientEmails'}
                      type='text'
                      fullWidth={true}
                      onChange={event => onDataEntry(event, 'clientEmails')}
                      value={formData['clientEmails'] || ''}
                      required={true}
                      disabled={false}
                    />
                  </Box>
                  {isvalidemail === false && (
                    <Typography
                      color='error'
                      variant='caption'
                      sx={{ fontSize: '14px' }}>
                      Please enter a valid email address.
                    </Typography>
                  )}
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    HR Violation Notify Email(s)
                  </Typography>
                  <SelectTagsComponent
                    tags={formData['hrViolationNotifyEmails']}
                    setTags={(emails: any) =>
                      onDataEntry(
                        {
                          target: {
                            value: emails
                              ?.map((email: any) => email?.trim())
                              .filter((email: any) => email !== ''),
                            name: 'hrViolationNotifyEmails',
                          },
                        },
                        'hrViolationNotifyEmails'
                      )
                    }
                  />
                  {ishrvalidemail === false && (
                    <Typography
                      color='error'
                      variant='caption'
                      sx={{ fontSize: '14px' }}>
                      Please enter a valid email address.
                    </Typography>
                  )}
                </Grid>
                {/* Service */}
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    Service
                  </Typography>
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '1px solid #DBDBDB',
                      padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                    }}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}>
                    <Input
                      disableUnderline
                      sx={{
                        width: '100%',
                        fontSize: '17px',
                        '& input::placeholder': {
                          fontWeight: 'bold',
                        },
                      }}
                      name={'service'}
                      type='text'
                      fullWidth={true}
                      onChange={event => onDataEntry(event, 'service')}
                      value={formData['service'] || ''}
                      required={true}
                      disabled={false}
                    />
                  </Box>
                </Grid>
                {/* Project Time Zone */}
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    Project Time Zone
                  </Typography>
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '1px solid #DBDBDB',
                      // padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                    }}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}>
                    <Select
                      labelId='demo-controlled-open-select-label'
                      id='demo-controlled-open-select'
                      value={formData['projectTimeZone']}
                      name='projectTimeZone'
                      sx={{
                        width: '100%',
                        border: 'none',
                        boxShadow: 'none',
                        padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                        '& .MuiSelect-select': {
                          padding: theme.spacing(0.8, 0, 0.8, 0),
                        },
                        '&:hover, & fieldset, & fieldset:hover': {
                          border: 'none',
                          // padding: 0,
                          margin: 0,
                          boxShadow: 'none',
                        },
                      }}
                      // @ts-ignore
                      onChange={onDataEntry}>
                      {timezones &&
                        timezones.map((option: any, key: any) => (
                          <MenuItem key={key} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                    </Select>
                  </Box>
                </Grid>
                {/* Daily Start Time */}
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    Daily Start Time
                  </Typography>
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      padding: theme.spacing(0.85, 1, 0.85, 1.6),
                      border: '1px solid #E5E3EA',
                      width: '100%',
                    }}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        label=''
                        onChange={e => onDataEntry(e, 'dailyStartTime')}
                        value={formData['dailyStartTime'] ?? null}
                        renderInput={(params: any) => {
                          return (
                            <TextField
                              {...params}
                              name='dailyStartTime'
                              variant='standard'
                              required
                              value={
                                formData['dailyStartTime']
                                  ? dayjs(formData['dailyStartTime']).format(
                                      'hh:mm A'
                                    )
                                  : ''
                              }
                              type={params.inputProps.type}
                              placeholder={params.inputProps.placeholder}
                              onChange={params.inputProps.onChange}
                              className={params.className}
                              inputProps={{
                                ...params,
                                readOnly: true,
                              }}
                              onClick={(event: any) => {
                                // @ts-ignore
                                params.InputProps.endAdornment.props.children.props.onClick()
                              }}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {/* {formData['dailyStartTime'] && (
                                      <IconButton
                                        onClick={() => {
                                          onDataEntry({
                                            target: {
                                              name: 'dailyStartTime',
                                              value: '',
                                            },
                                          })
                                        }}>
                                        <ClearIcon />
                                      </IconButton>
                                    )} */}
                                    <IconButton
                                      {...params.InputProps}
                                      // @ts-ignore
                                      onClick={(event: any) => {
                                        // @ts-ignore
                                        params.InputProps.endAdornment.props.children.props.onClick()
                                      }}>
                                      <CalendarIcon />
                                    </IconButton>
                                  </>
                                ),
                              }}
                              sx={{
                                width: '100%',
                                '& .MuiInput-underline:before': {
                                  display: 'none',
                                },
                                '& .MuiInput-underline:hover:not(.Mui-disabled):before':
                                  {
                                    display: 'none',
                                  },
                                '& .MuiInput-underline:after': {
                                  display: 'none',
                                },
                              }}
                            />
                          )
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
                {/* Daily End Time */}
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    Daily End Time
                  </Typography>
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      padding: theme.spacing(0.85, 1, 0.85, 1.6),
                      border: '1px solid #E5E3EA',
                      width: '100%',
                    }}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        label=''
                        onChange={e => onDataEntry(e, 'dailyEndTime')}
                        value={formData['dailyEndTime'] ?? ''}
                        renderInput={(params: any) => {
                          return (
                            <TextField
                              {...params}
                              required
                              value={params.inputProps.value}
                              type={params.inputProps.type}
                              placeholder={params.inputProps.placeholder}
                              onChange={params.inputProps.onChange}
                              className={params.className}
                              inputProps={{
                                ...params,
                                readOnly: true,
                              }}
                              onClick={(event: any) => {
                                // @ts-ignore
                                params.InputProps.endAdornment.props.children.props.onClick()
                              }}
                              name='dailyEndTime'
                              variant='standard'
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <IconButton
                                    {...params.InputProps}
                                    // @ts-ignore
                                    onClick={(event: any) => {
                                      // @ts-ignore
                                      params.InputProps.endAdornment.props.children.props.onClick()
                                    }}>
                                    <CalendarIcon />
                                  </IconButton>
                                ),
                              }}
                              sx={{
                                width: '100%',
                                '& .MuiInput-underline:before': {
                                  display: 'none',
                                },
                                '& .MuiInput-underline:hover:not(.Mui-disabled):before':
                                  {
                                    display: 'none',
                                  },
                                '& .MuiInput-underline:after': {
                                  display: 'none',
                                },
                              }}
                            />
                          )
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
                {/* Automatic Clock Out? */}
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    Automatic Clock Out?
                  </Typography>
                  <RadioGroup
                    aria-labelledby={`automaticClockOut_label`}
                    defaultValue=''
                    value={formData['automaticClockOutEnabled'] ?? false}
                    name={'automaticClockOutEnabled'}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      flexDirection: 'row',
                      padding: theme.spacing(0.85, 1, 0.85, 0),
                    }}
                    onChange={event => {
                      const isEnabled = event.target.value === 'true'

                      if (isEnabled) {
                        onDataEntry(null, 'automaticClockOutTime')
                      }
                      onDataEntry(isEnabled, 'automaticClockOutEnabled')
                    }}>
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label={'Yes'}
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label={'No'}
                    />
                  </RadioGroup>
                </Grid>
                {/* Automatic Clock Out Time */}
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    Automatic Clock Out Time
                  </Typography>
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      padding: theme.spacing(0.85, 1, 0.85, 1.6),
                      border: '1px solid #E5E3EA',
                      width: '100%',
                    }}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        label=''
                        onChange={time => {
                          const selectedTime = time !== '' ? time : null
                          onDataEntry(selectedTime, 'automaticClockOutTime')
                        }}
                        value={
                          formData['automaticClockOutEnabled']
                            ? formData['automaticClockOutTime'] ?? null
                            : null
                        }
                        renderInput={(params: any) => {
                          return (
                            <TextField
                              {...params}
                              name='automaticClockOutTime'
                              variant='standard'
                              required={
                                formData['automaticClockOutEnabled']
                                  ? true
                                  : false
                              }
                              value={params.inputProps.value}
                              type={params.inputProps.type}
                              placeholder={params.inputProps.placeholder}
                              onChange={params.inputProps.onChange}
                              className={params.className}
                              inputProps={{
                                ...params,
                              }}
                              onClick={(event: any) => {
                                // @ts-ignore
                                params.InputProps.endAdornment.props.children.props.onClick()
                              }}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <IconButton
                                    {...params.InputProps}
                                    // @ts-ignore
                                    onClick={(event: any) => {
                                      // @ts-ignore
                                      params.InputProps.endAdornment.props.children.props.onClick()
                                    }}>
                                    <CalendarIcon />
                                  </IconButton>
                                ),
                              }}
                              sx={{
                                width: '100%',
                                '& .MuiInput-underline:before': {
                                  display: 'none',
                                },
                                '& .MuiInput-underline:hover:not(.Mui-disabled):before':
                                  {
                                    display: 'none',
                                  },
                                '& .MuiInput-underline:after': {
                                  display: 'none',
                                },
                              }}
                              onKeyDown={e => {
                                if (
                                  !isNaN(Number(e.key)) ||
                                  ['a', 'A', 'p', 'P', 'm', 'M'].includes(e.key)
                                ) {
                                  e.preventDefault()
                                }
                              }}
                            />
                          )
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    Who should receive email notifications for open time cards?
                  </Typography>
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      padding: theme.spacing(0.85, 1, 0.85, 1.6),
                      border: '1px solid #E5E3EA',
                      width: '100%',
                    }}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}>
                    <Input
                      disableUnderline
                      sx={{
                        width: '100%',
                        fontSize: '17px',
                        '& input::placeholder': {
                          fontWeight: 'bold',
                        },
                      }}
                      name={'notificationEmails'}
                      type='text'
                      fullWidth={true}
                      onChange={event =>
                        onDataEntry(event, 'notificationEmails')
                      }
                      value={formData['notificationEmails'] || ''}
                      required={true}
                      disabled={false}
                    />
                  </Box>
                  {isvalidemailnotifi === false && (
                    <Typography
                      color='error'
                      variant='caption'
                      sx={{ fontSize: '14px' }}>
                      Please enter a valid email address.
                    </Typography>
                  )}
                </Grid>
                {/* Daily Grace Time (in minutes) */}
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    Daily Grace Time (in minutes)
                  </Typography>
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '1px solid #DBDBDB',
                      padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                    }}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}>
                    <Input
                      disableUnderline
                      sx={{
                        width: '100%',
                        fontSize: '17px',
                        '& input::placeholder': {
                          fontWeight: 'bold',
                        },
                      }}
                      name={'dailyGraceTime'}
                      type='number'
                      fullWidth={true}
                      onChange={event => {
                        const target = event.target as HTMLInputElement
                        const value = target.value
                        if (
                          value === '' ||
                          (parseInt(value) >= 0 && parseInt(value) <= 999)
                        ) {
                          onDataEntry(event,'dailyGraceTime')
                        }
                      }}
                      onInput={event => {
                        const input = event.target as HTMLInputElement
                        if (input.value.length > 3) {
                          input.value = input.value.slice(0, 3)
                        }
                      }}
                      value={formData['dailyGraceTime'] || ''}
                      required={true}
                      disabled={false}
                    />
                  </Box>
                  {dailyGraceError && (
                    <Typography
                      color='error'
                      variant='caption'
                      sx={{ fontSize: '14px' }}>
                      {dailyGraceError}
                    </Typography>
                  )}
                </Grid>
                {/* Lunch Break Duration */}
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    Lunch Break Duration
                  </Typography>
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '1px solid #DBDBDB',
                    }}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}>
                    <Select
                      labelId='demo-controlled-open-select-label'
                      id='demo-controlled-open-select'
                      value={formData['lunchDuration'] || 30}
                      name='lunchDuration'
                      sx={{
                        width: '100%',
                        border: 'none',
                        boxShadow: 'none',
                        padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                        '& .MuiSelect-select': {
                          padding: theme.spacing(0.8, 0, 0.8, 0),
                        },
                        '&:hover, & fieldset, & fieldset:hover': {
                          border: 'none',
                          // padding: 0,
                          margin: 0,
                          boxShadow: 'none',
                        },
                      }}
                      // @ts-ignore
                      onChange={onDataEntry}>
                      {[
                        { label: '30 Minutes', value: 30 },
                        { label: '45 Minutes', value: 45 },
                        { label: '60 Minutes', value: 60 },
                      ].map((option: any, key: any) => (
                        <MenuItem key={key} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Grid>
                {/* Superintendents */}
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    Superintendents
                  </Typography>
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '1px solid #DBDBDB',
                    }}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}>
                    <Select
                      labelId='demo-controlled-open-select-label'
                      id='demo-controlled-open-select'
                      value={users}
                      name='superintendents'
                      // required
                      multiple
                      sx={{
                        width: '100%',
                        border: 'none',
                        boxShadow: 'none',
                        padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                        '& .MuiSelect-select': {
                          padding: theme.spacing(0.8, 0, 0.8, 0),
                        },
                        '&:hover, & fieldset, & fieldset:hover': {
                          border: 'none',
                          // padding: 0,
                          margin: 0,
                          boxShadow: 'none',
                        },
                      }}
                      displayEmpty
                      renderValue={selected => {
                        if (selected.length === 0) {
                          return (
                            <span style={{ color: '#A9A9A9' }}>
                              Select Superintendents
                            </span>
                          ) // Placeholder text when nothing is selected
                        }
                        return selected
                          .map((item: any) => {
                            return accountUsers?.find((e: any) => e._id == item)
                              ?.email
                          })
                          .join(', ')
                      }}
                      // @ts-ignore
                      onChange={(
                        event?: React.ChangeEvent<HTMLSelectElement> | any
                      ) => {
                        const {
                          target: { value },
                        } = event
                        setPersonName(
                          typeof value === 'string' ? value.split(',') : value
                        )
                        const selectedOptions = event.target.value
                        setUsers(selectedOptions)
                        const selectedUsers = {
                          name: 'superintendents',
                          value: selectedOptions,
                        }
                        onDataEntry(selectedUsers, 'superintendents')
                      }}>
                      {accountUsers?.filter(
                        (user: { type: string }) =>
                          user.type === 'superintendent'
                      ).length === 0 ? (
                        <MenuItem disabled>No Superintendents</MenuItem>
                      ) : (
                        accountUsers
                          ?.filter(
                            (user: { type: string }) =>
                              user.type === 'superintendent'
                          )
                          .map((user: any, key: any) => {
                            return (
                              <MenuItem key={key} value={user._id}>
                                <Checkbox
                                  checked={
                                    users.findIndex((e: any) => e == user._id) >
                                    -1
                                  }
                                />
                                {user.email}
                              </MenuItem>
                            )
                          })
                      )}
                    </Select>
                  </Box>
                </Grid>
                {/* Enable Kiosk Mode */}
                <Grid item xs={12} sm={12} md={12} lg={6}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    Kiosk Mode Enabled?
                  </Typography>
                  <RadioGroup
                    aria-labelledby={`kioskEnabled_label`}
                    defaultValue=''
                    value={formData['kioskEnabled'] ?? false}
                    name={'kioskEnabled'}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      flexDirection: 'row',
                      padding: theme.spacing(0.85, 1, 0.85, 0),
                    }}
                    onChange={event => {
                      const isEnabled = event.target.value === 'true'
                      setKioskEnabled(isEnabled)
                      onDataEntry(event)
                    }}>
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label={'Yes'}
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label={'No'}
                    />
                  </RadioGroup>
                </Grid>

                {/* Location */}
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <PlaceComponent
                    field={{
                      fieldType: 'location',
                      name: 'location',
                      label: 'Location',
                      errorMessage:
                        'Oops, looks like your project does not have an location',
                      isRequired: false,
                    }}
                    // key={key}
                    onDataEntry={onDataEntry}
                    fieldValue={formData['locations']}
                  />
                </Grid>
                {/* End */}
              </Grid>
            </Box>
          </Box>
          <Stack spacing={2} direction='row'>
            {onSave && (
              <Button variant='contained' onClick={onSave}>
                Save Draft
              </Button>
            )}
            <Button
              type='submit'
              variant='contained'
              disabled={
                !!externalError ||
                !isvalidemail ||
                !isvalidemailnotifi ||
                !ishrvalidemail
              }>
              {submitLabel}
            </Button>
            <Button
              variant='contained'
              color='secondary'
              onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </Stack>
        </form>
      </div>
    </>
  )
}


  // {formData?.hrViolationNotifyEmails && formData?.hrViolationNotifyEmails?.map((item: any)=> item)}
